import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=50bfa73e&scoped=true"
import script from "./Upsert.vue?vue&type=script&lang=js"
export * from "./Upsert.vue?vue&type=script&lang=js"
import style0 from "./Upsert.vue?vue&type=style&index=0&id=50bfa73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfa73e",
  null
  
)

export default component.exports